module.exports = __webpack_public_path__ + "static/media/all-activities-un-active.f99f07f7.svg";